exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.handing-all-btn[data-v-d830d020] {\n  margin-left: 20px;\n  margin-top: 16px;\n}\n.handing-table[data-v-d830d020] {\n  margin-top: 16px;\n}\n.pagination[data-v-d830d020] {\n  margin-top: 12px;\n  text-align: right;\n}\n[data-v-d830d020] .el-table__body td {\n  padding: 10px 0 !important;\n  height: 40px !important;\n}\n", ""]);

// exports
